import {useMutation, useQueryClient} from '@tanstack/react-query';

/* Keys & Apis */
import {cart} from '@api/apis';
import {cartQueryKeys} from './queries.keys';

/* Utils */
import {Logger} from '@utils/logger';
import {handleResponseError} from '../utils/util.handleResponseError';

type UseCartAddCouponToCartProp = {
  couponCode: string;
  force?: boolean;
};

export default function useCartMutationAddCoupon() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({couponCode, force = false}: UseCartAddCouponToCartProp) => {
      const data = await cart.addCoupon({code: couponCode, force});
      if (data.status === 500) throw new Error(data.err);
      handleResponseError(data);

      return data;
    },
      onSuccess: data => {
        const {cart: cartResponse = {}} = data?.data ?? {};

        queryClient.setQueryData(cartQueryKeys.all, {...cartResponse});
      },
      onError: error => {
        Logger('useCartMutationAddCoupon')(error as Error);
      },
    }
  );
}
